import { isNullOrUndef } from "./object";

/* eslint-disable @typescript-eslint/no-explicit-any */
export function spliceSafety(
    list: any[],
    start: number,
    deleteCount: number | null = null
): any[] {
    if (isNullOrUndef(list)) return null;

    return list.splice(
        start,
        isNullOrUndef(deleteCount)
            ? list.length
            : Math.min(list.length, deleteCount)
    );
}

export function isEmptyList(values: any[]): boolean {
    return isNullOrUndef(values) || values.length === 0;
}

export function addOrRemove<T>(list: T[], item: T): T[] {
    return list.includes(item)
        ? list.filter((i) => i !== item)
        : [...list, item];
}

type T1 = {
    [k: string]: any;
};

export function toMapFromListById<T extends T1>(
    items: T[],
    key: string
): { [key: string]: T } {
    return items.reduce((acc, cur) => {
        acc[cur[key]] = cur;
        return acc;
    }, {} as { [key: string]: T });
}

export function generateMapGroupByKey<T extends T1>(
    items: T[],
    key: string,
    listName: string
): { [key: string]: any[] } {
    return items.reduce((acc, cur) => {
        const listByKey = acc[cur[key]];
        if (listByKey) {
            listByKey.push(cur[listName]);
        } else {
            acc[cur[key]] = [cur[listName]];
        }
        return acc;
    }, {} as { [key: string]: any[] });
}

export function toNumberListOrNull(param: any[] | any): number[] | null {
    if (isNullOrUndef(param)) return null;

    // listは単数でくる可能性あり
    if (!Array.isArray(param)) return [Number(param)];

    return param.map((p) => Number(p));
}

type Primitive = number | string | boolean;

// 差集合
export function difference<T extends Primitive>(arr1: T[], arr2: T[]): T[] {
    const arr2Set = new Set(arr2);
    return [...new Set(arr1)].filter((x) => !arr2Set.has(x));
}
